import React, { lazy, Suspense } from 'react';
import './App.css';

import { UserProvider, useUser } from 'context/UserContext';
import { QueryClientProvider } from 'utils/db/client';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

const ProtectedRoute = lazy(() => import('components/ProtectedRoute'));
const DashboardLayout = lazy(() => import('components/Dashboard/DashboardLayout'));

const LoginPage = lazy(() => import('components/LoginPage/LoginPage'));
const Dashboard = lazy(() => import('components/Dashboard/Dashboard'));
const ViewOrders = lazy(() => import('components/Roles/Manager/ViewOrders'));
const PlaceOrders = lazy(() => import('components/Roles/Manager/PlaceOrders'));
const ReviewOrders = lazy(() => import('components/Roles/Baker/ReviewOrders'));

const ReviewTodaysOrders = lazy(() => import('components/Roles/Baker/ReviewTodaysOrders'));
const Cafe = lazy(() => import('components/Roles/Admin/Cafe'));
const Items = lazy(() => import('components/Roles/Admin/Items'));
const Invoice = lazy(() => import('components/Roles/Admin/Invoice'));
const ShowOrders = lazy(() => import('components/Roles/Admin/ShowOrders'));
const CafeDetail = lazy(() => import('components/Roles/Admin/CafeDetail'));
const FavoriteOrder = lazy(() => import('components/Roles/Manager/FavoriteOrder'));
const BakerPlaceOrder = lazy(() => import('components/Roles/Baker/BakerPlaceOrder'));



const fallback = <div style={{ backgroundColor: "black", height: "100vh" }} />;

const AppRoutes = () => {
  const { loading } = useUser();
  if (loading) return fallback;

  return (
    <Routes>
      <Route path="/" element={<Suspense fallback={fallback}><LoginPage /></Suspense>} />
      <Route element={<Suspense fallback={fallback}><ProtectedRoute /></Suspense>}>
        <Route path="dashboard" element={<Suspense fallback={fallback}><DashboardLayout /></Suspense>}>
          <Route index element={<Suspense fallback={fallback}><Dashboard /></Suspense>} />
          <Route path="view-orders" element={<Suspense fallback={fallback}><ViewOrders /></Suspense>} />
          <Route path="place-order" element={<Suspense fallback={fallback}><PlaceOrders /></Suspense>} />
          <Route path="favorite-order" element={<Suspense fallback={fallback}><FavoriteOrder /></Suspense>} />
          <Route path="review-orders" element={<Suspense fallback={fallback}><ReviewOrders /></Suspense>} />
          <Route path="review-todays-orders" element={<Suspense fallback={fallback}><ReviewTodaysOrders /></Suspense>} />
          <Route path="baker-place-order" element={<Suspense fallback={fallback}><BakerPlaceOrder /></Suspense>} />
         

          <Route path="cafes" element={<Suspense fallback={fallback}><Cafe /></Suspense>} />
          <Route path="cafes/:cafeId" element={<Suspense fallback={fallback}><CafeDetail /></Suspense>} />
          <Route path="items" element={<Suspense fallback={fallback}><Items /></Suspense>} />
        </Route>
      </Route>
    </Routes>
  );
};

function App() {
  return (
    <QueryClientProvider>
      <UserProvider>
        <Router>
          <AppRoutes />
        </Router>
      </UserProvider>
    </QueryClientProvider>
  );
}

export default App;
